export type Anchor = [number, number];

export const lerp = (a: number, b: number, f: number): number => a + (b - a) * f;

export function interpLogLog(a: Anchor, b: Anchor, x: number): number {
  const [x1, y1] = a, [x2, y2] = b;
  const t = (Math.log(x) - Math.log(x1)) / (Math.log(x2) - Math.log(x1));
  return Math.exp(Math.log(y1) + t * (Math.log(y2) - Math.log(y1)));
}

/* Baseline value for `hours` from anchor set; extrapolates on end segments. */
export function baseline(anchors: Anchor[], hours: number): number {
  if (hours <= anchors[0]![0]) return interpLogLog(anchors[0]!, anchors[1]!, hours);
  for (let i = 0; i < anchors.length - 1; i++) {
    if (hours <= anchors[i + 1]![0]) return interpLogLog(anchors[i]!, anchors[i + 1]!, hours);
  }
  const n = anchors.length;
  return interpLogLog(anchors[n - 2]!, anchors[n - 1]!, hours);
}

/* Inverse of `baseline`: hours that yield value `y` (curve decreasing in x). */
export function baselineInvHours(anchors: Anchor[], y: number): number {
  const inv = (a: Anchor, b: Anchor): number => {
    const [x1, y1] = a, [x2, y2] = b;
    const t = (Math.log(y) - Math.log(y1)) / (Math.log(y2) - Math.log(y1));
    return Math.exp(Math.log(x1) + t * (Math.log(x2) - Math.log(x1)));
  };
  if (y >= anchors[0]![1]) return inv(anchors[0]!, anchors[1]!);
  for (let i = 0; i < anchors.length - 1; i++) {
    if (y >= anchors[i + 1]![1]) return inv(anchors[i]!, anchors[i + 1]!);
  }
  const n = anchors.length;
  return inv(anchors[n - 2]!, anchors[n - 1]!);
}
